/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';

import * as Styles from '@components/modals/styles';
import { ILooseObject } from '@interface/loose-object';
import { swapCollect } from '@lib/beacon';
import { testNodeHealth } from '@utils/node';
import { AlertDialog, Field, Input } from '@versumstudios/ui';

export interface ISwapCollect {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  swapId?: number;
  swapPrice?: number;
  swapMaxQuantity?: number;
  creatorsTotal?: number;
}

export const SwapCollect: FC<ISwapCollect> = ({
  open,
  onOpenChange,
  swapId,
  swapPrice,
  swapMaxQuantity,
  creatorsTotal,
}) => {
  const [values, setValues] = useState<ILooseObject>({
    quantity: { error: false, data: 1 },
  });

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.quantity.data) {
      setError('quantity', '"Quantity" is missing');
      valid = false;
    }

    if (values.quantity.data < 1 || values.quantity.data > swapMaxQuantity!) {
      setError('quantity', `"Quantity" needs to be between 1 and ${swapMaxQuantity}.`);
      valid = false;
    }

    return valid;
  };

  const handleConfirm = async () => {
    if (validate()) {
      await testNodeHealth();
      swapCollect(swapId!, swapPrice! * values.quantity.data, Number(values.quantity.data), creatorsTotal);

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  return (
    <AlertDialog
      title="Collect"
      description="You're about to collect this token."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        <Field uid="quantity" label="Quantity" tooltip="How many editions to collect" error={values.quantity.error}>
          <Input
            type="number"
            min={1}
            max={swapMaxQuantity}
            placeholder="e.g.: 1"
            value={values.quantity.data}
            onChange={(value: string) => handleChange('quantity', value)}
          />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
